import React from "react";
import { Lock, LogOut, TimerOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import logoDark from "@/assets/logo-dark.png";

export default function Bloqueado() {
  const { logout } = useAuth();
  const teste = new URLSearchParams(window.location.search).get("m") === "teste";
  return (
    <div className="min-h-screen bg-onyx flex flex-col items-center justify-center p-6 text-center" data-testid="bloqueado-page">
      <img src={logoDark} alt="TRT" className="h-14 mb-8" />
      <div className="w-20 h-20 rounded-full bg-red-500/15 border border-red-500/30 flex items-center justify-center mb-6">{teste ? <TimerOff className="w-10 h-10 text-red-400" /> : <Lock className="w-10 h-10 text-red-400" />}</div>
      {teste ? <>
        <h1 className="text-white text-2xl font-bold" data-testid="bloqueado-titulo">Teste encerrado. Entre em contato com o administrador.</h1>
        <p className="text-slate-400 mt-2 max-w-md">O período de teste grátis de 7 dias terminou. Seus dados estão preservados e o acesso será liberado assim que o administrador ativar a assinatura.</p>
      </> : <>
        <h1 className="text-white text-2xl font-bold" data-testid="bloqueado-titulo">Acesso temporariamente bloqueado</h1>
        <p className="text-slate-400 mt-2 max-w-md">A mensalidade da sua empresa está pendente. Regularize com o suporte da plataforma para liberar o acesso. Seus dados estão preservados.</p>
      </>}
      <Button onClick={async () => { await logout(); window.location.href = "/login"; }} variant="outline" className="mt-8 gap-2 border-white/20 text-white hover:bg-white/10" data-testid="bloqueado-sair"><LogOut className="w-4 h-4" /> Sair</Button>
    </div>
  );
}
